// @flow
'use strict';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';

import Filtros from './filtros';

export default compose(
    connect<*, *, *, *, *, *>(),
    withRouter,
)(Filtros);
